import { useCssModule, computed } from "vue";
import "./assets/index-CgZzOVq6.js";
import "vue-demi";
import { u as useDataTestIdProp } from "./assets/index-BNd8MWnO.js";
import { u as useDisabledProp } from "./assets/index-DKxr0Yto.js";
import { X as XIcon, u as useIconProps } from "./assets/XIcon-U9bwokTN.js";
import { B as BaseLink, u as useLinkProps } from "./assets/BaseLink-KuovKwoP.js";
import "./assets/index-vzP2cezV.js";
import "vue-router";
import "dompurify";
import "@vueuse/core";
import { n as normalizeComponent } from "./assets/_plugin-vue2_normalizer-VvYS6rEj.js";
import "vue-i18n";
import "./locales.js";
import "@fortawesome/vue-fontawesome";
import "./assets/index-Ca8wHgNc.js";
const XLinkPlain = "_XLinkPlain_dw9p0_1";
const XLink$1 = "_XLink_dw9p0_1";
const sizeSmall = "_sizeSmall_dw9p0_27";
const noPadding = "_noPadding_dw9p0_30";
const right = "_right_dw9p0_33";
const icon = "_icon_dw9p0_33";
const isInverted = "_isInverted_dw9p0_36";
const isDisabled = "_isDisabled_dw9p0_46";
const style0 = {
  XLinkPlain,
  XLink: XLink$1,
  sizeSmall,
  noPadding,
  right,
  icon,
  isInverted,
  isDisabled
};
const { createIconProps } = useIconProps();
const { createLinkProps } = useLinkProps();
const { createDisabledProp } = useDisabledProp();
const { createTestIdProp, setupTestId } = useDataTestIdProp();
const __default__ = {
  name: "XLink",
  components: { XIcon, BaseLink }
};
const _sfc_main = /* @__PURE__ */ Object.assign(__default__, {
  props: {
    inverted: {
      type: Boolean,
      default: false
    },
    iconPosition: {
      type: String,
      default: "left",
      validator: (position) => /left|right/.test(position)
    },
    small: Boolean,
    plain: Boolean,
    noPadding: Boolean,
    ...createLinkProps(),
    ...createIconProps(),
    ...createDisabledProp(),
    ...createTestIdProp()
  },
  emits: ["click"],
  setup(__props) {
    const props = __props;
    const $style = useCssModule();
    const { formatTestId } = setupTestId(props);
    const iconSize = computed(() => props.small ? "sm" : "1x");
    const baseClass = computed(() => ({
      [$style.XLink]: !props.plain,
      [$style.XLinkPlain]: props.plain
    }));
    const linkClasses = computed(() => ({
      ...baseClass.value,
      [$style.isInverted]: props.inverted,
      [$style.sizeSmall]: props.small,
      [$style.noPadding]: props.noPadding,
      [$style[props.iconPosition]]: true
    }));
    return { __sfc: true, createIconProps, createLinkProps, createDisabledProp, createTestIdProp, setupTestId, props, $style, formatTestId, iconSize, baseClass, linkClasses, BaseLink, XIcon };
  }
});
var _sfc_render = function render() {
  var _vm = this, _c = _vm._self._c, _setup = _vm._self._setupProxy;
  return _c(_setup.BaseLink, _vm._b({ class: [_setup.linkClasses], attrs: { "aria-disabled": _vm.disabled, "data-testid": _setup.formatTestId() }, on: { "click": ($event) => _vm.$emit("click", $event) } }, "BaseLink", { ..._vm.$props, ..._vm.$attrs }, false), [_vm.icon ? _c(_setup.XIcon, { class: _setup.$style.icon, attrs: { "icon": _vm.icon, "icon-style": _vm.iconStyle, "size": _setup.iconSize, "data-testid": _setup.formatTestId("icon"), "fixed-width": true } }) : _vm._e(), _vm._t("default")], 2);
};
var _sfc_staticRenderFns = [];
const __cssModules = {
  "$style": style0
};
function _sfc_injectStyles(ctx) {
  for (var key in __cssModules) {
    this[key] = __cssModules[key];
  }
}
var __component__ = /* @__PURE__ */ normalizeComponent(
  _sfc_main,
  _sfc_render,
  _sfc_staticRenderFns,
  false,
  _sfc_injectStyles
);
const XLink = __component__.exports;
export {
  XLink as default
};
